// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simulator {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-color: #013020;
    color: #ffcb00;
}

.simulator h1 {
    text-align: center;
    color: #ffcc00;
    margin-bottom: 20px;
}

.simulator-selection {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.selectors {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    position: relative; /* Ensure relative positioning for children to stack correctly */
}

.custom-select {
    position: relative;
    width: 200px;
    margin: 0 10px;
    z-index: 1;
}

.custom-select label {
    position: absolute;
    left: 10px;
    top: -10px;
    background-color: #013020;
    padding: 0 5px;
    font-size: 13px;
    font-weight: bold;
    color: #ffcb00;
    transition: all 0.3s ease;
    z-index: 2;
}

.custom-select-selected {
    background-color: #013020;
    border: 2px solid #265d38;
    padding: 12px 12px 8px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;
    color: #ffcb00;
}

.custom-select-selected:hover {
    border-color: #ffcb00;
}

.custom-select-selected.active {
    border-color: #ffcb00;
}

.custom-select-selected::after {
    content: '▼';
    font-size: 0.6em;
    margin-bottom: 3px;
    margin-left: 5px;
}

.custom-select-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #013020;
    border: 2px solid #265d38;
    border-top: none;
    border-radius: 0 0 5px 5px;
    z-index: 999; /* Increase the z-index so it's always on top */
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.custom-select-options::-webkit-scrollbar {
    width: 8px;
}

.custom-select-options::-webkit-scrollbar-track {
    background-color: #013020;
}

.custom-select-options::-webkit-scrollbar-thumb {
    background-color: #265d38;
    border-radius: 4px;
}

.custom-select-option {
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    color: #ffcb00;
}

.custom-select-option:hover {
    background-color: #265d38;
}

.continue-button {
    display: block;
    width: 200px;
    margin: 20px auto;
    padding: 10px 20px;
    font-size: 18px;
    color: #013020;
    background-color: #ffcb00;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.continue-button:hover {
    background-color: #ffdd33;
}

.warning {
    color: #ff6b6b;
    background-color: rgba(255, 107, 107, 0.1);
    border: 1px solid #ff6b6b;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    text-align: center;
    font-weight: bold;
}

.continue-button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

.continue-button:disabled:hover {
    background-color: #cccccc;
}

/* Mobile view adjustments */
@media (max-width: 768px) {
    .selectors {
        flex-direction: column;
    }

    .custom-select {
        width: 100%;
        margin: 10px 0;
    }

    /* Ensure the dropdowns stack correctly without overlapping */
    .custom-select-options {
        position: static;
        z-index: 9999; /* Ensure it's on top when opened */
    }
}
`, "",{"version":3,"sources":["webpack://./src/CourseSimulator.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB,EAAE,gEAAgE;AACxF;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY,EAAE,+CAA+C;IAC7D,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA,6DAA6D;IAC7D;QACI,gBAAgB;QAChB,aAAa,EAAE,mCAAmC;IACtD;AACJ","sourcesContent":[".simulator {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    background-color: #013020;\n    color: #ffcb00;\n}\n\n.simulator h1 {\n    text-align: center;\n    color: #ffcc00;\n    margin-bottom: 20px;\n}\n\n.simulator-selection {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.selectors {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n    position: relative; /* Ensure relative positioning for children to stack correctly */\n}\n\n.custom-select {\n    position: relative;\n    width: 200px;\n    margin: 0 10px;\n    z-index: 1;\n}\n\n.custom-select label {\n    position: absolute;\n    left: 10px;\n    top: -10px;\n    background-color: #013020;\n    padding: 0 5px;\n    font-size: 13px;\n    font-weight: bold;\n    color: #ffcb00;\n    transition: all 0.3s ease;\n    z-index: 2;\n}\n\n.custom-select-selected {\n    background-color: #013020;\n    border: 2px solid #265d38;\n    padding: 12px 12px 8px;\n    border-radius: 5px;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: all 0.3s ease;\n    position: relative;\n    z-index: 1;\n    color: #ffcb00;\n}\n\n.custom-select-selected:hover {\n    border-color: #ffcb00;\n}\n\n.custom-select-selected.active {\n    border-color: #ffcb00;\n}\n\n.custom-select-selected::after {\n    content: '▼';\n    font-size: 0.6em;\n    margin-bottom: 3px;\n    margin-left: 5px;\n}\n\n.custom-select-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: #013020;\n    border: 2px solid #265d38;\n    border-top: none;\n    border-radius: 0 0 5px 5px;\n    z-index: 999; /* Increase the z-index so it's always on top */\n    max-height: 200px;\n    overflow-y: auto;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.custom-select-options::-webkit-scrollbar {\n    width: 8px;\n}\n\n.custom-select-options::-webkit-scrollbar-track {\n    background-color: #013020;\n}\n\n.custom-select-options::-webkit-scrollbar-thumb {\n    background-color: #265d38;\n    border-radius: 4px;\n}\n\n.custom-select-option {\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    color: #ffcb00;\n}\n\n.custom-select-option:hover {\n    background-color: #265d38;\n}\n\n.continue-button {\n    display: block;\n    width: 200px;\n    margin: 20px auto;\n    padding: 10px 20px;\n    font-size: 18px;\n    color: #013020;\n    background-color: #ffcb00;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.continue-button:hover {\n    background-color: #ffdd33;\n}\n\n.warning {\n    color: #ff6b6b;\n    background-color: rgba(255, 107, 107, 0.1);\n    border: 1px solid #ff6b6b;\n    padding: 10px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    text-align: center;\n    font-weight: bold;\n}\n\n.continue-button:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n}\n\n.continue-button:disabled:hover {\n    background-color: #cccccc;\n}\n\n/* Mobile view adjustments */\n@media (max-width: 768px) {\n    .selectors {\n        flex-direction: column;\n    }\n\n    .custom-select {\n        width: 100%;\n        margin: 10px 0;\n    }\n\n    /* Ensure the dropdowns stack correctly without overlapping */\n    .custom-select-options {\n        position: static;\n        z-index: 9999; /* Ensure it's on top when opened */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
